import { t } from 'i18next'
import { Button } from 'primereact/button'
import { Dialog } from 'primereact/dialog'
import React from 'react'
// @ts-ignore
import allowPopup from '../../../assets/images/allow-popup.jpg'

export const AllowPopupDialog = (props: {
  showDialog: boolean;
  closeDialog: () => void;
  link?: string;
}) => {
  return (
    <Dialog
      header={t<string>('core.error.popup_blocked.title')}
      onHide={props.closeDialog}
      visible={props.showDialog}
      footer={
        <Button
          className={'ml-auto mr-0 p-button-warning'}
          label={t<string>('core.close_hint')}
          type={'button'}
          onClick={props.closeDialog}
        />
      }
      closeOnEscape
    >
      <img
        height={327}
        width={942}
        src={allowPopup}
        alt={'how to allow popup'}
        style={{ maxWidth: '100%' }}
      />

      <p>
        <b>{t<string>('core.error.popup_blocked.message')}</b>
      </p>

      <ol>
        <li>{t<string>('core.error.popup_blocked.step_one')}</li>
        <li>{t<string>('core.error.popup_blocked.step_two')}</li>
      </ol>

      <p>{t<string>('core.error.popup_blocked.browser_difference')}</p>
      {props.link && (
        <div
          className={
            'inline-flex justify-content-center align-items-center mt-4'
          }
        >
          {' '}
          <Button
            className={'p-button '}
            type={'button'}
            icon={'fa-solid fa-file'}
            label={t<string>('core.error.popup_blocked.open_blocked_link')}
            onClick={() => window.open(props.link)}
          />{' '}
          <span className={'small-text secondary-text ml-2'}>
            {t<string>('core.error.popup_blocked.link_expiration_time')}
          </span>
        </div>
      )}
    </Dialog>
  )
}